import { Deserializable } from '../interfaces';

export class UpdateProfile implements Deserializable {
  foto: File | '';
  idUsuarioValor: string | null;
  nombre: string | null;
  correoElectronico: string | null;
  claveTelefono: string | null;
  telefono: string | null;
  contrasena: string | null;
  idUsuario: string | null;
  idioma: string | null;

  constructor() {
    this.foto = '';
    this.idUsuarioValor = null;
    this.nombre = null;
    this.correoElectronico = null;
    this.claveTelefono = null;
    this.telefono = null;
    this.contrasena = null;
    this.idUsuario = null;
    this.idioma = null;
  }

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
